import { supabase } from "../supabaseClient";

async function compressImage(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = (e) => {
      const img = new Image();

      img.src = e.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");

        const SIZE = 600;

        canvas.width = SIZE;
        canvas.height = SIZE;

        const ctx = canvas.getContext("2d");

        ctx.drawImage(img, 0, 0, SIZE, SIZE);

        canvas.toBlob(
          (blob) => {
            resolve(blob);
          },
          "image/jpeg",
          0.85,
        );
      };

      img.onerror = reject;
    };

    reader.onerror = reject;
  });
}

export async function uploadAvatar(file, token, memberId) {
  if (!file) throw new Error("Aucun fichier sélectionné.");

  const compressed = await compressImage(file);

  const formData = new FormData();

  formData.append("file", compressed, "avatar.jpg");

  const res = await fetch(
    `/api/membre?action=uploadAvatar&memberId=${memberId}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    },
  );

  const data = await res.json();

  if (!data.success) {
    alert(JSON.stringify(data));
    throw new Error(data.message || "Erreur upload");
  }

  return data.url;
}
